import reduceReducers from 'reduce-reducers'

import { default as AccountReducer } from './Account'
import { default as DocumentsReducer } from './Documents'
import { default as SurveyReducer } from './Survey'
import { default as FinanceReducer } from './Finance'

export * from './Account'
export * from './Finance'
export * from './Documents'
export * from './Survey'

// Export types and initialState from separate file to avoid circular dependencies
import { types, initialState } from './types'
export { types, initialState }
export default reduceReducers(
  AccountReducer,
  FinanceReducer,
  DocumentsReducer,
  SurveyReducer,
  // the last arg MUST be the shared state
  initialState,
)
